<template>
  <div :class="{ 'o-card': !tab }">
    <Table
      no-card
      :title="$t(`${name}.title`)"
      :description="$t(`${name}.titleDescription`)"
      i18n
      :loading="loading"
      :items="items"
      checkable
      :status="$status.departments"
      :checkValue="checkedList"
      @change:sort="SET_CHANGE_SORT"
      @change:checkedList="checkedList = $event"
      @change:selectAllWithoutPage="SET_CHECKED_ALL"
      :headers="headers"
      :page="page"
      :count="count"
      :pages="pages"
      :searchValue="search"
      @change:search="setSearch"
      @change:page="setChangedPage"
      :searchPlaceholder="$t(`${name}.searchPlaceholder`)"
    >
      <template #new-button>
        <div class="u-display-flex u-width-100% u-justify-content-flex-end">
          <router-link
            v-if="getActiveUser.userInfo.role === 'Admin'"
            :to="{ name: 'admins' }"
          >
            <Button variant="primary" class="u-margin-right-xsmall">
              {{ $t(`navigation.admins`) }}
            </Button>
          </router-link>
          <ExcelExport
            :fileName="`${name}-export-${date()}`"
            :fields="exportFields"
            :data="checkedList.length > 0 ? checkedList : items"
          >
            <template #button="{ showExcell }">
              <Button
                @click="showExcell()"
                variant="light-success"
                class="u-margin-right-xsmall"
              >
                <i class="icofont-arrow-up"></i> {{ $t("common.export") }}
              </Button>
            </template>
          </ExcelExport>

          <Button variant="light-primary" @click="newDepartmentModal = true">
            + {{ $t(`${name}.add`) }}
          </Button>
        </div>
      </template>
      <template #title="{ item }">
        <div class="u-cursor-pointer">
          <router-link
            :to="{
              name: `department-detail`,
              params: { departmentId: item.id },
            }"
          >
            <span> {{ item.title }} </span>
          </router-link>
        </div>
      </template>
      <template #info="{ item }">
        <div class="u-margin-bottom-xsmall">
          <chip
            class="u-margin-0"
            :variant="item.isActive ? 'success' : 'danger'"
          >
            {{ item.isActive ? $tc("common.active") : $tc("common.passive") }}
          </chip>
        </div>
        <div class="u-color-primary">
          <i class="icofont-calendar"></i> {{ date(item.createdDate) }}
        </div>
      </template>
      <template #updatedDate="{ item }">
        <div class="u-color-primary">
          <i class="icofont-calendar"></i> {{ date(item.updatedDate) }}
        </div>
      </template>
      <template #action="{ item }">
        <div
          class="u-display-flex u-align-items-center u-justify-content-flex-end"
        >
          <Dropdown align="right">
            <template #title>
              <div class="u-font-size-xlarge u-padding-left">
                <i class="icofont-bubble-down"></i>
              </div>
            </template>
            <template #content>
              <ul class="c-list">
                <li class="c-list__item" @click="showDetail(item)">
                  <span>
                    <i class="icofont-edit u-margin-right-xsmall"></i>
                    {{ $t("common.edit") }}</span
                  >
                </li>
                <router-link
                  :to="{
                    name: `department-detail`,
                    query: { departmentId: item.id },
                  }"
                >
                  <li class="c-list__item">
                    <span>
                      <i class="icofont-eye u-margin-right-xsmall"></i>
                      {{ $t("common.goToDetail") }}</span
                    >
                  </li>
                </router-link>
                <li @click="REMOVE_TO(item)" class="c-list__item">
                  <span>
                    <i class="icofont-trash u-margin-right-xsmall"></i>
                    {{ $t("common.remove") }}</span
                  >
                </li>
              </ul>
            </template>
          </Dropdown>
        </div>
      </template>
    </Table>
    <RemoveModal @ok="REMOVE_ITEM" v-model="removeModal.status"></RemoveModal>
    <DepartmentForm
      v-model="newDepartmentModal"
      :edit="showDetailModal.item ? true : false"
      :form="showDetailModal.item"
      @refresh="getItemsOfPage"
      key="new"
    ></DepartmentForm>
  </div>
</template>

<script>
import Table from "@/components/Base/Table/index.vue";
import DateHelper from "@/helpers/date";
import { mapGetters } from "vuex";
import Button from "../Base/Button.vue";
import Dropdown from "../Base/Dropdown.vue";
import RemoveModal from "@/components/Shared/RemoveModal/index.vue";
import ExcelExport from "../Base/ExcelExport.vue";
import Requests from "@/services/Requests";
import Chip from "../Base/Chip.vue";
import DepartmentForm from "./DepartmentForm.vue";
export default {
  components: {
    Dropdown,
    RemoveModal,
    Table,
    Button,
    ExcelExport,
    Chip,
    DepartmentForm,
  },
  props: {
    query: {
      type: Object,
      default: () => {
        return {};
      },
    },
    noFilter: {
      type: Boolean,
      default: false,
    },
    tab: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      name: "departments",
      checkedList: [],
      showLockedModal: false,
      showRemoveModal: false,
      newDepartmentModal: false,
      filter: {},
      sort: {},
      get: {
        title: "mainProjects",
        dispatch: "getMainProjects",
      },
      update: {
        title: "updateMainProjects",
        dispatch: "updateMainProject",
        lockedStatus: "isLocked",
      },
      remove: {
        title: "removeMainProjects",
        dispatch: "removeMainProject",
      },
      page: 1,
      search: "",
      items: [],
      loading: true,
      count: 0,
      headers: [
        {
          col: 10,
          sm: 4,
          md: 4,
          lg: 4,
          title: "departments.title",
          value: "title",
        },
        {
          col: 10,
          sm: 3,
          md: 3,
          lg: 3,
          title: "departments.description",
          value: "description",
        },
        {
          col: 10,
          sm: 3,
          md: 3,
          lg: 3,
          title: "common.info",
          value: "info",
          sortable: true,
        },
        {
          col: 2,
          sm: 1,
          md: 1,
          lg: 1,
          align: "right",
          title: "common.action",
          value: "action",
        },
      ],
      removeModal: { status: false, item: {} },
      lockedModal: { status: false, item: {} },
      showDetailModal: { status: false, adminDetailStatus: false, item: null },
    };
  },
  watch: {
    newDepartmentModal(value) {
      if (!value) {
        this.showDetailModal = {
          status: false,
          adminDetailStatus: false,
          item: null,
        };
      }
    },
  },
  computed: {
    ...mapGetters({
      getActiveUser: "getActiveUser",
    }),
    pages() {
      return Math.ceil(this.count / 10);
    },
    exportFields() {
      if (this.items.length === 0) return {};
      return {
        [this.$t("departments.title")]: {
          field: "title",
          callback: (value) => {
            return value;
          },
        },
        [this.$t("departments.description")]: {
          field: "description",
          callback: (value) => {
            return value;
          },
        },
        [this.$t("common.createdDate")]: {
          field: "createdDate",
          callback: (value) => {
            return this.$date.format(value || new Date());
          },
        },
        [this.$t("common.updatedDate")]: {
          field: "updatedDate",
          callback: (value) => {
            return this.$date.format(value || new Date());
          },
        },
      }; //this.getExcelFields();
    },
  },
  methods: {
    SET_CHANGE_SORT(headers) {
      const sortedHeaders = headers.filter((item) => item.sort);
      if (sortedHeaders.length === 0) {
        this.sort = {};
        this.getItemsOfPage();
      } else {
        const sort = sortedHeaders[0];
        if (sort.sort.includes("name")) {
          const value = sort.sort.split("-")[1];
          this.sort = {
            sort: value.toUpperCase(),
            sortFilter: "ALPHABETIC",
          };
        } else if (sort.sort.includes("info")) {
          const value = sort.sort.split("-")[1];
          this.sort = {
            sort: value.toUpperCase(),
            sortFilter: "DATE",
          };
        }
        this.getItemsOfPage();
      }
    },
    async SET_CHECKED_ALL(data) {
      if (data) {
        this.$store.dispatch("SET_ACTION_MODAL", {
          isLoading: true,
          status: true,
        });
        const response = await Requests.Department.GetAll({
          query: { page: 1, limit: this.count, search: this.search },
        });
        this.$status.departments = response.message;
        if (response.message === "OK") {
          console.log(response.data);

          this.checkedList = [...response.data.items];
        }
        this.$store.dispatch("SET_ACTION_MODAL", {
          isLoading: false,
          status: false,
        });
      }
    },
    showDetail(item) {
      this.showDetailModal = {
        status: true,
        item: item,
      };
      this.newDepartmentModal = true;
    },
    date(value = new Date()) {
      const date = new DateHelper(this.$i18n.locale);
      return date.format(value);
    },
    SET_LOCKED_DESCRIPTION() {
      return this.lockedModal.item.isLocked ? "unlocked" : "locked";
    },
    REMOVE_TO(item) {
      this.removeModal = {
        status: true,
        item: item,
      };
    },
    async REMOVE_ITEM(loading) {
      loading(true);

      const response = await Requests.Department.Delete({
        params: { id: this.removeModal.item.id },
      });
      if (response.message === "OK") {
        this.getItemsOfPage();
        this.$store.dispatch("SET_ACTION_MODAL", {
          isLoading: false,
          status: true,
          message: this.$t(`common.removeSuccess`),
          variant: "success",
          duration: 2500,
        });
      } else {
        this.$store.dispatch("SET_ACTION_MODAL", {
          isLoading: false,
          status: true,
          message: this.$t(`common.removeError`),
          variant: "danger",
          duration: 2500,
        });
      }
      loading(false);
    },
    setQuery() {
      const page = Number(this.$route.query.page);
      const search = this.$route.query.search;
      if (!isNaN(page)) this.page = page;
      if (search) this.search = search;
      this.getItemsOfPage();
    },
    async getItemsOfPage() {
      this.loading = true;
      this.removeModal = { status: false, item: {} };
      this.lockedModal = { status: false, item: {} };
      const response = await Requests.Department.GetAll({
        query: {
          limit: 10,
          page: this.page,
          search: this.search,
          ...this.filter,
          ...this.sort,
          ...this.query,
        },
      });
      this.$status.departments = response.message;
      if (response.message === "OK") {
        this.items = response.data.items;
        this.count = response.data.count;
      }
      this.loading = false;
    },
    setSearch(search) {
      this.search = search;
      this.page = 1;
      this.$router.replace({
        query: { ...this.$route.query, search: this.search, page: 1 },
      });
      this.getItemsOfPage();
    },
    setChangedPage(page) {
      this.$router.replace({
        query: { ...this.$route.query, page: page },
      });
      this.page = page;
      this.getItemsOfPage();
    },
    setFilter(filter) {
      const filterScoped = {
        type: filter.type || "",
        isLocked:
          filter.isLocked == null
            ? ""
            : filter.isLocked
            ? "true"
            : "false" || "",
        userId: filter.user?.id || "",
        batteryId: filter.batteryId?.id || "",
      };
      // remove
      this.filter = filterScoped;
      this.getItemsOfPage(filterScoped);
    },
  },
  mounted() {
    this.setQuery();
  },
};
</script>

<style></style>
